"use client";

import { HomeView } from "@/components/home-view";
import { KidsBoard } from "@/components/kids-board";
import { PeopleBoard } from "@/components/people-board";
import { SettingsForm } from "@/components/settings-form";
import { TimetableCard } from "@/components/timetable-card";
import { TodayBoard } from "@/components/today-board";
import { VotesBoard } from "@/components/votes-board";
import { useMeContext } from "@/components/me-provider";
import type { TodayResponse } from "@/lib/types";

export function ScheduleView({ active = true }: { active?: boolean }) {
  return <TimetableCard active={active} />;
}

export function VotesView({ active = true }: { active?: boolean }) {
  const me = useMeContext();
  return <VotesBoard me={me} active={active} />;
}

export function TabScreen({ href, active }: { href: string; active: boolean }) {
  switch (href) {
    case "/":
      return <HomeView active={active} />;
    case "/schedule":
      return <ScheduleView active={active} />;
    case "/votes":
      return <VotesView active={active} />;
    case "/kids":
      return <KidsView active={active} />;
    case "/people":
      return <PeopleView active={active} />;
    case "/settings":
      return <SettingsView />;
    default:
      return null;
  }
}

export function KidsView({ active = true }: { active?: boolean }) {
  const me = useMeContext();
  return <KidsBoard me={me} active={active} />;
}

export function PeopleView({ active = true }: { active?: boolean }) {
  const me = useMeContext();
  return <PeopleBoard me={me} active={active} />;
}

export function SettingsView() {
  const me = useMeContext();
  return <SettingsForm me={me} />;
}

export function TodayView({ initialToday, active = true }: { initialToday?: TodayResponse; active?: boolean }) {
  const me = useMeContext();
  return <TodayBoard me={me} initialToday={initialToday} active={active} />;
}
